export const getSelectedService = (services, serviceId) =>
  services.find(service => service.serviceId === serviceId);
